import { emailIsValid, isValidString, } from "@pineapplelab/util";
import { Core } from "../../core/core";
/**
 * The value must be a valid email.
*/
export function IsEmail(options) {
    if (options === void 0) { options = {}; }
    return function (target, propertyKey) {
        var message = "The field: '" + (options.label ? options.label : propertyKey) + "' must be a valid email.";
        Core.setFieldValidator(target, propertyKey, {
            name: 'IsEmail',
            isValid: function (o, f) { return isValidString(o[f]) && emailIsValid(o[f]); },
            message: options.message ? options.message : message
        });
    };
}
